import Vue from 'vue';
import VueRouter from 'vue-router';

import DefaultPage from './layouts/Default-page';
import LoginPage from './layouts/Login-page';
import ErrorPage from './layouts/Error-page';
import PageNotFound from './components/error/PageNotFound';

import Home from './pages/Home';
import Statements from './pages/Statements';
import Payment from './pages/Payment';
import Settings from './pages/Settings/index';
import EditProfile from './pages/Settings/EditProfile';
import PaymentMethods from './pages/Settings/PaymentMethods/index';
import AddNewCard from './pages/Settings/PaymentMethods/AddNewCard';
import AddressBook from './pages/Settings/AddressBook';
import Documents from './pages/Settings/Documents';
import Support from './pages/Support';
import Login from './pages/Login';
import SelectUser from './pages/SelectUser';
import FAQ from './pages/FAQ';
import Lang from "lang.js";

import helper from './services/helper';
import store from './store';


Vue.use(VueRouter);
var lang = new Lang();

let routes = [
    {
        path: '/',
        component: DefaultPage,
        meta: {requiresAuth: true},
        children: [
            {
                path: '/',
                component: Home,
                name: 'home',
                meta: {
                    homePage: true,
                    pageTitle: lang.get('layouts/navigation.my-dashboard'),
                }
            },
            {
                path: '/statements',
                component: Statements,
                name: 'statements',
                meta: {
                    statementsPage: true,
                    pageTitle: lang.get('layouts/navigation.statements'),
                }
            },
            {
                path: '/payment:loan?',
                component: Payment,
                meta: {
                    paymentPage: true,
                    pageTitle: lang.get('layouts/navigation.payment'),
                }
            },
            {
                path: '/settings',
                component: Settings,
                meta: {
                    settingsPage: true,
                    pageTitle: lang.get('layouts/navigation.settings'),
                },
            },
            {
                path: '/settings/edit-profile',
                component: EditProfile,
                meta: {
                    settingsPage: true,
                    pageTitle: lang.get('pages/settings/index.my-details'),
                    pageSubTitle: lang.get('pages/settings/index.sub-title-update'),
                }
            },
            {
                path: '/settings/payment-methods',
                component: PaymentMethods,
                meta: {
                    settingsPage: true,
                    pageTitle: lang.get('pages/settings/index.payment-methods'),
                    pageSubTitle: lang.get('pages/settings/index.sub-title-add'),
                }
            },
            {
                path: '/settings/address-book',
                component: AddressBook,
                meta: {
                    settingsPage: true,
                    pageTitle: lang.get('pages/settings/index.address-settings'),
                }
            },
            {
                path: '/settings/payment-methods/add-new-card',
                component: AddNewCard,
                meta: {
                    settingsPage: true,
                    pageTitle: lang.get('pages/settings/payment-methods.index.title'),
                }
            },
            {
                path: '/settings/documents',
                component: Documents,
                meta: {
                    settingsPage: true,
                    pageTitle: lang.get('components/sidebar/documents.title'),
                }
            },
            {
                path: '/support',
                component: Support,
                meta: {
                    supportPage: true,
                    pageTitle: lang.get('pages/support.page-title')
                }
            },
            {
                path: '/faq',
                component: FAQ,
                meta: {
                    faqPage: true,
                    pageTitle: lang.get('pages/faq.title')
                }
            },
        ]
    },
    {
        path: '/',
        component: LoginPage,
        meta: {requiresGuest: true},
        children: [
            {
                path: '/login',
                component: Login
            },
        ]
    },
    {
        path: '/select-user',
        component: SelectUser,
        name: 'selectUser',
        meta: {
            selectUser: true,
            requiresAuth: true,
            pageTitle: lang.get('pages/home.select-account')
        }
    },

    {
        path: '*',
        component: ErrorPage,
        children: [
            {
                path: '*',
                component: PageNotFound
            }
        ]
    }
];


const router = new VueRouter({
    routes,
    linkActiveClass: '',
    linkExactActiveClass: 'active',
    mode: 'history'
});

router.beforeEach((to, from, next) => {

    if (to.matched.some(m => m.meta.requiresAuth)) {

        if ( (to.name !== 'selectUser' && from.name !== 'selectUser') || (to.path ==='/' && from.name === 'selectUser') ) {

            if (to.path === '/payment' && to.query.loan_id) {

                return next({
                    path: '/payment',
                    query: {
                        loan: to.query.loan_id,
                        payment: to.query.payment,
                        status: to.query.status,
                        listen_url: to.query.listen_url,
                    }
                });
            }

            store.dispatch('getUserInfo').then(() => {
                if (!store.state.user.name) {
                    console.log('!!');
                    return next({path: '/select-user'});
                }
            });
        }

        helper.check().then(response => {

            if (!response) {
                return next({path: '/login'})
            }
            return next();
        });
    }

    if (to.matched.some(m => m.meta.requiresGuest)) {
        console.log('res');

        return helper.check().then(response => {
            if (response) {
                return next({path: '/'});
            }

            return next();
        });
    }

    return next();
});


export default router;
